






































import { Vue, Component, Watch } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { NamedOnboarding as OnboardingRouteName } from "@/employee/route-names";
import { useContributionStore } from "@/shared/store/contribution";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import { FetchState, PlanType } from "@/shared/types";
import _ from "lodash";

interface PlanDetailsDisplay {
  planType: PlanType;
  healthPlanEffectiveDate: string;
}

const emptyPlanDetails: PlanDetailsDisplay = {
  planType: PlanType.None,
  healthPlanEffectiveDate: ""
};

@Component({
  components: {
    Button,
    GenericLoadingSpinner
  }
})
export default class ReviewHealthPlan extends Vue {
  contributionStore = useContributionStore();

  planDetails = _.cloneDeep(emptyPlanDetails);

  get isLoaded () {
    return this.contributionStore.planDetailsFetchState === FetchState.Loaded;
  }

  get isFailed () {
    return this.contributionStore.planDetailsFetchState === FetchState.Failed;
  }

  @Watch("contributionStore.planDetails")
  onPlanDetailsChanged () {
    this.initializeFromState();
  }

  mounted () {
    this.initializeFromState();
    this.contributionStore.getPlanDetails();
  }

  initializeFromState () {
    this.planDetails = _.cloneDeep(emptyPlanDetails);

    if (!this.contributionStore.planDetails) {
      return;
    }

    const data = this.contributionStore.planDetails;

    this.planDetails = {
      planType: data.planType,
      healthPlanEffectiveDate: formatMMddyyyyDateString(data.healthPlanEffectiveDate)
    };
  }

  goToStep (stepKey: string) {
    this.$router.push({ name: OnboardingRouteName, params: { stepKey } });
  }
}
